import { ListCategoryDoc } from '../../redux-toolkits/categories/categories.type'
import { ActionChip } from './actionChip'

export const CategoryCard = ({
  category,
  showIcon = true,
}: {
  category: ListCategoryDoc
  showIcon?: boolean
}) => {
  return (
    <ActionChip
      icon={showIcon ? category.icon : undefined}
      name={category.name}
      className="max-w-fit"
    />
  )
}
